import React from 'react';

const Contact = () => {
  return (
    <div className="t-main">
      <h1>ติดต่อผู้ดูแลระบบ</h1>
      <div className="sec-box">
        <table className="t-table-blank">
          <tr>
            <td>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                  fill="#00B833"
                />
                <path
                  d="M20 11.3C20 10.4042 19.7917 9.56042 19.375 8.76875C18.9479 7.97709 18.3698 7.28959 17.6406 6.70625C16.9219 6.1125 16.0781 5.64896 15.1094 5.31563C14.1406 4.97188 13.1042 4.8 12 4.8C10.8958 4.8 9.85938 4.97188 8.89063 5.31563C7.92188 5.64896 7.07292 6.1125 6.34375 6.70625C5.625 7.28959 5.05208 7.97709 4.625 8.76875C4.20833 9.56042 4 10.4042 4 11.3C4 12.0917 4.16667 12.8521 4.5 13.5813C4.84375 14.3 5.3125 14.9458 5.90625 15.5188C6.5 16.0813 7.20313 16.5552 8.01563 16.9406C8.83854 17.326 9.72917 17.5813 10.6875 17.7063C10.8125 17.7375 10.9479 17.7792 11.0938 17.8313C11.25 17.8833 11.3542 17.9667 11.4063 18.0813C11.4375 18.1854 11.4479 18.3104 11.4375 18.4563C11.4375 18.5917 11.4271 18.7167 11.4063 18.8313C11.4063 18.8313 11.3906 18.9302 11.3594 19.1281C11.3281 19.3156 11.3125 19.4354 11.3125 19.4875C11.3021 19.5917 11.3073 19.7375 11.3281 19.925C11.349 20.1125 11.5729 20.1125 12 19.925C12.2083 19.8417 12.5729 19.6438 13.0938 19.3313C13.625 19.0188 14.2031 18.6438 14.8281 18.2063C15.4531 17.7688 16.0781 17.2948 16.7031 16.7844C17.3281 16.274 17.8542 15.7792 18.2813 15.3C18.8542 14.6646 19.2813 14.0188 19.5625 13.3625C19.8542 12.7063 20 12.0188 20 11.3ZM8.875 13.425H7.28125C7.17708 13.425 7.07813 13.3885 6.98438 13.3156C6.89063 13.2323 6.84375 13.1333 6.84375 13.0188V9.83125C6.84375 9.70625 6.88542 9.60209 6.96875 9.51875C7.0625 9.43542 7.16667 9.39375 7.28125 9.39375C7.38542 9.39375 7.47917 9.43542 7.5625 9.51875C7.64583 9.60209 7.6875 9.70625 7.6875 9.83125V12.5813H8.875C8.97917 12.5813 9.07292 12.6229 9.15625 12.7063C9.23958 12.7896 9.28125 12.8938 9.28125 13.0188C9.28125 13.1229 9.23958 13.2167 9.15625 13.3C9.08333 13.3833 8.98958 13.425 8.875 13.425ZM10.5 13.0188C10.5 13.1229 10.4583 13.2167 10.375 13.3C10.3021 13.3833 10.2083 13.425 10.0938 13.425C9.98958 13.425 9.89583 13.3885 9.8125 13.3156C9.72917 13.2323 9.6875 13.1333 9.6875 13.0188V9.83125C9.6875 9.70625 9.72396 9.60209 9.79688 9.51875C9.88021 9.43542 9.97917 9.39375 10.0938 9.39375C10.1979 9.39375 10.2917 9.43542 10.375 9.51875C10.4583 9.60209 10.5 9.70625 10.5 9.83125V13.0188ZM14.3438 13.0188C14.3438 13.0917 14.3177 13.1646 14.2656 13.2375C14.2135 13.3104 14.1458 13.3625 14.0625 13.3938C14.0313 13.4042 14.0052 13.4146 13.9844 13.425C13.9635 13.425 13.9375 13.425 13.9063 13.425C13.8438 13.425 13.7813 13.4146 13.7188 13.3938C13.6667 13.3625 13.625 13.3208 13.5938 13.2688L11.9688 11.05V13.0188C11.9688 13.1229 11.9271 13.2167 11.8438 13.3C11.7604 13.3833 11.6563 13.425 11.5313 13.425C11.4271 13.425 11.3333 13.3885 11.25 13.3156C11.1667 13.2323 11.125 13.1333 11.125 13.0188V9.83125C11.125 9.7375 11.1458 9.65417 11.1875 9.58125C11.2396 9.50834 11.3125 9.45625 11.4063 9.425C11.4167 9.425 11.4323 9.41979 11.4531 9.40938C11.4844 9.39896 11.5104 9.39375 11.5313 9.39375C11.5938 9.39375 11.651 9.40938 11.7031 9.44063C11.7656 9.47188 11.8229 9.51875 11.875 9.58125L13.5 11.8V9.83125C13.5 9.70625 13.5365 9.60209 13.6094 9.51875C13.6927 9.43542 13.7917 9.39375 13.9063 9.39375C14.0313 9.39375 14.1354 9.43542 14.2188 9.51875C14.3021 9.60209 14.3438 9.70625 14.3438 9.83125V13.0188ZM16.9063 10.9875C17.0313 10.9875 17.1354 11.0292 17.2188 11.1125C17.3021 11.1958 17.3438 11.3 17.3438 11.425C17.3438 11.5292 17.3021 11.6229 17.2188 11.7063C17.1354 11.7896 17.0313 11.8313 16.9063 11.8313H15.75V12.5813H16.9063C17.0313 12.5813 17.1354 12.6229 17.2188 12.7063C17.3021 12.7896 17.3438 12.8938 17.3438 13.0188C17.3438 13.1229 17.3021 13.2167 17.2188 13.3C17.1354 13.3833 17.0313 13.425 16.9063 13.425H15.3125C15.2083 13.425 15.1146 13.3885 15.0313 13.3156C14.9479 13.2323 14.9063 13.1333 14.9063 13.0188V11.425V9.83125C14.9063 9.70625 14.9427 9.60209 15.0156 9.51875C15.099 9.43542 15.1979 9.39375 15.3125 9.39375H16.9063C17.0313 9.39375 17.1354 9.43542 17.2188 9.51875C17.3021 9.60209 17.3438 9.70625 17.3438 9.83125C17.3438 9.93542 17.3021 10.0292 17.2188 10.1125C17.1354 10.1958 17.0313 10.2375 16.9063 10.2375H15.75V10.9875H16.9063Z"
                  fill="white"
                />
              </svg>
            </td>
            <td>
              <h2 className="mb-0">LINE</h2>
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>
              <b>กลุ่มไลน์ (Line Group) &nbsp;</b>
            </td>
            <td>
              <a
                href="https://line.me/ti/g2/mai18A0ezfqw55pdsNzpYiORRxmE1oe-CW5l9A?utm_source=invitation&utm_medium=link_copy&utm_campaign=default"
                target="_blank"
                rel="noopener noreferrer"
              >
                School.MyTCAS
              </a>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <b>รหัสเข้ากลุ่ม (Password) &nbsp;</b>
            </td>
            <td>sch2024</td>
          </tr>
          <tr>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                  fill="#FF9301"
                />
                <path
                  d="M15.36 13.44C14.88 13.92 14.56 14.36 14.4 14.76C14.24 15.16 13.92 15.36 13.44 15.36C12.96 15.36 12.48 15.16 12 14.76C11.52 14.36 11.04 13.92 10.56 13.44C10.08 12.96 9.63999 12.48 9.23999 12C8.83999 11.52 8.63999 11.04 8.63999 10.56C8.63999 10.08 8.83999 9.76 9.23999 9.6C9.63999 9.44 10.08 9.12 10.56 8.64C10.8 8.4 10.83 8.065 10.65 7.635C10.47 7.205 10.2 6.78 9.83999 6.36C9.47999 5.94 9.08999 5.575 8.66999 5.265C8.24999 4.955 7.91999 4.8 7.67999 4.8C7.43999 4.8 7.15499 4.95 6.82499 5.25C6.49499 5.55 6.17999 5.88 5.87999 6.24C5.57999 6.6 5.32499 6.93 5.11499 7.23C4.90499 7.53 4.79999 7.68 4.79999 7.68C4.79999 8.16 4.90999 8.74 5.12999 9.42C5.35999 10.11 5.65499 10.82 6.01499 11.55C6.38499 12.27 6.79499 12.965 7.24499 13.635C7.70499 14.315 8.16999 14.89 8.63999 15.36C9.10999 15.83 9.68499 16.295 10.365 16.755C11.035 17.205 11.73 17.615 12.45 17.985C13.18 18.345 13.89 18.64 14.58 18.87C15.26 19.09 15.84 19.2 16.32 19.2C16.32 19.2 16.47 19.095 16.77 18.885C17.07 18.675 17.4 18.42 17.76 18.12C18.12 17.82 18.45 17.505 18.75 17.175C19.05 16.845 19.2 16.56 19.2 16.32C19.2 16.08 19.045 15.75 18.735 15.33C18.425 14.91 18.06 14.52 17.64 14.16C17.22 13.8 16.795 13.53 16.365 13.35C15.935 13.17 15.6 13.2 15.36 13.44Z"
                  fill="white"
                />
              </svg>
            </td>
            <td>
              <h2 className="mb-0">MOBILE</h2>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <b>แหม่ม (สุวิมล)</b>
            </td>
            <td>089-899-8363</td>
          </tr>
          <tr>
            <td colspan="3"></td>
          </tr>
          <tr>
            <td>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                  fill="#3F51B5"
                />
                <path
                  d="M7.33337 6.66669C6.28671 6.66669 5.42655 7.47335 5.33988 8.50002L12 12.0964L18.6602 8.50002C18.5735 7.47335 17.7134 6.66669 16.6667 6.66669H7.33337ZM5.33337 9.63023V15.3334C5.33337 16.4367 6.23004 17.3334 7.33337 17.3334H16.6667C17.77 17.3334 18.6667 16.4367 18.6667 15.3334V9.63023L12.237 13.1068C12.1637 13.1468 12.0834 13.1667 12 13.1667C11.9167 13.1667 11.8364 13.1468 11.7631 13.1068L5.33337 9.63023Z"
                  fill="white"
                />
              </svg>
            </td>
            <td>
              <h2 className="mb-0">EMAIL</h2>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <b>สำหรับสถาบัน</b>
            </td>
            <td>
              <a href="mailto:university@mytcas.com">university@mytcas.com</a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Contact;
